export const STRIPE_SECRET_KEY =
  process.env.REACT_APP_MODE === "LIVE"
    ? process.env.REACT_APP_STRIPE_SECRET_KEY_LIVE
    : process.env.REACT_APP_STRIPE_SECRET_KEY_TEST;

export const STRIPE_API_KEY =
  process.env.REACT_APP_MODE === "LIVE"
    ? process.env.REACT_APP_STRIPE_API_KEY_LIVE
    : process.env.REACT_APP_STRIPE_API_KEY_TEST;

export const STRIPE_CLIENT_ID =
  process.env.REACT_APP_MODE === "LIVE"
    ? process.env.REACT_APP_STRIPE_CLIENT_ID_LIVE
    : process.env.REACT_APP_STRIPE_CLIENT_ID_TEST;

export const PLAID_PUBLIC_KEY = process.env.REACT_APP_PLAID_PUBLIC_KEY;
